<template>
  <div class="main">
    <report-top v-if="!scan">
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="getList"
      ></ly-search>
    </report-top>
    <selectTool ref="selectTool">
      <template slot="text">位置标注点列表</template>
      <template slot="btn"
        ><Button @click="getList" type="error" class="chaxun">查询</Button
        ><Button @click="openAdd" type="primary" class="chaxun">检索</Button
        ><Button @click="openDel" type="primary" class="chaxun">删除</Button>
      </template>
    </selectTool>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
      @on-selection-change="selectData = $event"
    >
      <template #imgs="{ row }">
        <imgList :data="row.filesPathList"></imgList>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <Button v-if="checkMore" @click="$emit('objs', selectData)" type="success"
        >我选好了</Button
      >
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>

    <form-model
      @close="close"
      width="800"
      ref="formModel"
      title="开始创建"
      :overAuto="false"
      :labelWidth="110"
    >
      <template #suffix>
        <Button @click="autoGetAddress">地图获取</Button>
      </template>
      <Button slot="btn" type="primary" @click="addUpdate">提交</Button>
    </form-model>
  </div>
</template>
<script>
let devices = [],
  devicesGoal = [];
let typss = [
  {
    id: "COPY",
    name: "检索",
  },
  {
    id: "DELETE",
    name: "删除",
  },
];
export default {
  data() {
    let defaultItem = {
      taskType: "COPY",
      deviceNoList: [],
      sourceDeviceNo: "",
      targetDeviceNo: "",
      sourceStartTime: "",
      sourceEndTime: "",
      targetStartTime: "",
      targetEndTime: "",
    };
    return {
      openForm: false,
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 40,
        },

        {
          title: "源设备",
          key: "sourceDeviceNo",
        },
        {
          title: "目标设备",
          key: "targetDeviceNo",
        },
        {
          title: "源数量",
          key: "dataTotal",
        },
        {
          title: "完成数量",
          key: "completeTotal",
        },
        {
          title: "状态",
          key: "taskStatus",
          render: (h, data) => {
            let obj = {
              SUBMITTED: "提交",
              PROGRESS: "进行中",
              COMPLETED: "成功",
              FAILED: "失败",
            };
            return h("p", obj[data.row.taskStatus]);
          },
        },
        {
          title: "进度",
          key: "taskProgress",
          render: (h, data) => {
            return h("p", data.row.taskProgress + "%");
          },
        },
        {
          title: "总耗时",
          key: "taskDuration",
          render: (h, data) => {
            let m = data.row.taskDuration / 1000;
            let time =
              m > 60 ? (m / 60).toFixed(1) + "分" : m.toFixed(1) + "秒";
            return h("p", time);
          },
        },
        {
          title: "描述信息",
          key: "taskDescribe",
        },
        {
          title: "源开始时间",
          key: "sourceStartTime",
          render: (h, data) => {
            return h("p", this.utils.time(data.row.sourceStartTime, "yymmdd"));
          },
        },
        {
          title: "源结束时间",
          key: "sourceEndTime",
          render: (h, data) => {
            return h("p", this.utils.time(data.row.sourceEndTime, "yymmdd"));
          },
        },
        {
          title: "目标开始时间",
          key: "targetStartTime",
          render: (h, data) => {
            let time = this.utils.time(data.row.targetStartTime, "yymmdd");
            if (data.row.taskType == "DELETE") {
              time = null;
            }
            return h("p", time);
          },
        },
        {
          title: "目标结束时间",
          key: "targetEndTime",
          render: (h, data) => {
            let time = this.utils.time(data.row.targetEndTime, "yymmdd");
            if (data.row.taskType == "DELETE") {
              time = null;
            }
            return h("p", time);
          },
        },
        {
          title: "创建时间",
          key: "taskCreateTime",
          render: (h, data) => {
            return h("p", this.utils.time(data.row.taskCreateTime));
          },
        },
        {
          title: "类型",
          key: "taskType",
          render: (h, data) => {
            let a = typss.find((item) => item.id == data.row.taskType);
            return h("p", a.name);
          },
        },
        {
          title: "操作",
          slot: "action",
          width: 160,
          align: "center",
          fixed: "right",
          sort: 20,
        },
      ],
      tableData: [],
      item: { ...defaultItem },
      defaultItem,
      forms: [],
      searchItem: { pageNumber: 1, pageSize: 20, keyword: "" },

      total: 0,
      selectData: [],
      time: null,
    };
  },
  methods: {
    getList() {
      // this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url:
          this.axios.ipPort +
          "/cloud-customized-server-xzr/trackTask/selectPage",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        //var data = [{ name: "11111" }];
        this.tableData = data;
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.item.sourceEndTime = this.item.sourceEndTime + 86400 * 1000 - 1000;
      this.item.targetEndTime = this.item.targetEndTime + 86400 * 1000 - 1000;

      if (this.isAdd) {
        this.axios({
          method: "post",
          url:
            this.axios.ipPort + "/cloud-customized-server-xzr/trackTask/create",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();

            this.getList();
            this.fresh();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-ep-server-event/work/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url:
              this.axios.ipPort +
              "/cloud-customized-server-xzr/trackTask/delete",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              if (this.outUse) {
                this.$emit("ok");
              } else {
                this.getList();
              }
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.item = { ...this.defaultItem };
      this.isAdd = true;
      this.getDevice();
      //this.getDeviceGoal();
      this.item.taskType = "COPY";
      let forms = [
        {
          title: "源设备",
          key: "sourceDeviceNo",
          type: "Select",
          // multiple: true,
          required: true,
          selectType: "obj",
          selectItems: devices,
        },
        {
          title: "目标设备",
          key: "targetDeviceNo",
          type: "Select",
          // multiple: true,
          required: false,
          selectType: "obj",
          selectItems: devices,
        },
        {
          title: "源开始时间",
          key: "sourceStartTime",
          type: "lyyymmdd",
          required: true,
        },
        {
          title: "源结束时间",
          key: "sourceEndTime",
          type: "lyyymmdd",
          required: true,
        },
        {
          title: "目标开始时间",
          key: "targetStartTime",
          type: "lyyymmdd",
          required: true,
        },
        {
          title: "目标结束时间",
          key: "targetEndTime",
          type: "lyyymmdd",
          required: true,
        },
        {
          title: "类型",
          key: "taskType",
          type: "Select",
          selectType: "obj",
          selectItems: typss,
          disabled: true,
        },
      ];
      this.$refs.formModel.reach(forms, this.item);
    },
    openDel() {
      this.item = { ...this.defaultItem };
      this.isAdd = true;
      this.getDevice();
      this.item.taskType = "DELETE";
      let forms = [
        {
          title: "设备",
          key: "sourceDeviceNo",
          type: "Select",
          multiple: false,
          required: true,
          selectType: "obj",
          selectItems: devices,
        },
        {
          title: "源开始时间",
          key: "sourceStartTime",
          type: "lyyymmdd",
          required: true,
        },
        {
          title: "源结束时间",
          key: "sourceEndTime",
          type: "lyyymmdd",
          required: true,
        },

        {
          title: "类型",
          key: "taskType",
          type: "Select",
          selectType: "obj",
          selectItems: typss,
          disabled: true,
        },
      ];
      this.$refs.formModel.reach(forms, this.item);
    },
    getDevice() {
      this.axios({
        method: "post",
        url: this.axios.lbs + "/locate/getLocate",
        data: {
          returnCoord: 2,
        },
      }).then((res) => {
        this.$Spin.hide();
        let data = res.data.data;
        //data = data.filter((item) => item.active);

        devices.length = 0;
        for (let i = 0; i < data.length; i++) {
          var aaa = data[i].deviceUseType;
          data[i].name =
            aaa == null
              ? data[i].deviceNo
              : aaa == 1
              ? data[i].carNo + "[" + data[i].carTypeName + "]"
              : data[i].personName;
          let obj = {
            name: data[i].name,
            id: data[i].deviceNo,
            remark: data[i].deviceNo,
          };
          devices.push(obj);
        }
      });
    },
    getDeviceGoal() {
      this.axios({
        method: "post",
        url: this.axios.lbs + "/locate/getLocate",
        data: {
          returnCoord: 2,
        },
      }).then((res) => {
        this.$Spin.hide();
        let data = res.data.data;

        devicesGoal.length = 0;
        for (let i = 0; i < data.length; i++) {
          var aaa = data[i].deviceUseType;
          data[i].name =
            aaa == null
              ? data[i].deviceNo
              : aaa == 1
              ? data[i].carNo + "[" + data[i].carTypeName + "]"
              : data[i].personName;
          let obj = {
            name: data[i].name,
            id: data[i].deviceNo,
            remark: data[i].deviceNo,
          };
          devicesGoal.push(obj);
        }
      });
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    drawCir(v) {
      this.$refs.point.drawCir(v);
    },
    autoGetAddress() {
      var ccc = this.$refs.point.getPoint();
      var pointList = [
        {
          x: ccc.x,
          y: ccc.y,
        },
      ];
      this.utils.jiexi(pointList).then((data) => {
        this.item.address =
          data[0].address == null ? "暂无地址" : data[0].address;
      });
    },
    close() {
      this.$refs.point.destroyMap();
    },
    fresh() {
      clearInterval(this.time);
      let t = 0;
      this.time = setInterval(() => {
        t++;
        if (t < 15) {
          this.getList();
        } else {
          clearInterval(this.time);
        }
      }, 1000);
    },
  },
  mounted() {
    //this.columns = this.utils.cols(this.forms, this.columns);
    this.getList();
  },
  computed: {
    radius() {
      return this.item.radius;
    },
  },
  watch: {
    radius(v) {
      setTimeout(() => {
        this.drawCir(v);
      }, 500);
    },
  },
};
</script>
<style>
#sderwwetcsd {
  position: absolute;
  width: 240px;
  background: #fff;
  z-index: 3;
  top: 10px;
  right: 10px;
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/event/trackTask.vue